// src/layouts/MainLayout.jsx

import Sidebar from "../Components/Sidebar.jsx";
import Navbar from "../Components/Navbar.jsx";
import AppNotificationHandler from "../Components/AppNotificationHandler.jsx";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";
import { useEffect, useState } from "react";
import "./MainLayout.css";

export default function MainLayout() {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("sidebar-collapsed") === "true";
  });

  useEffect(() => {
    localStorage.setItem("sidebar-collapsed", isCollapsed);
  }, [isCollapsed]);

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/");
    } 
  }, [isAuthenticated, loading, navigate, user]);

  const isExemptFromOnboarding = true; // Always exempt in private edition

  if (loading || !isAuthenticated || (user && !user.onboarding_completed && !isExemptFromOnboarding)) {
    return <div style={{ background: '#0d0d0d', minHeight: '100vh' }} />;
  }

  return (
    <div className={`main-layout-container ${isCollapsed ? "collapsed" : ""}`}>
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

      <div className="main-content-wrapper">
        <Navbar />
        <AppNotificationHandler />
        <div className="content-padding">
          <Outlet />
        </div>
      </div>
    </div>
  );
}